import React, { useState } from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getServiceStatusChangesByReason } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';
const ServiceStatusReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'service-status',
    title: `${customCaptions?.service} Status Change Reasons`,
    fetchData: async (params) => {
      return await getServiceStatusChangesByReason(params);
    },
    allowedChartTypes: ['horizontal-bar', 'pie'],
    defaultChartType: 'horizontal-bar',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: 'Count' 
      }]
    },
    series: [
      { label: 'Count', key: 'count', colors: getAllColors(), showLegend: false }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: `${customCaptions?.model || 'Model'} Count` 
        }]
      },
      series: [
        { 
          label: `${customCaptions?.model || 'Model'} Count`, 
          key: 'count', 
          showLegend: false
        }
      ],
      currentDrilldownLabel: `${customCaptions?.model || 'Model'}`,
      getParams: (dataPoint) => {
        return {
          changeStatusReasonId: dataPoint.id
        };
      },
      drilldown: {
        axisConfig: {
          categoryAxis: { dataKey: 'label' },
          valueAxes: [{ 
            label: `${customCaptions?.asset || 'Asset'} Count` 
          }]
        },
        series: [
          { 
            label: `${customCaptions?.asset || 'Asset'} Count`, 
            key: 'count', 
            showLegend: false
          }
        ],
        currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
        getParams: (dataPoint) => {
          return {
            modelId: dataPoint.id
          };
        }
      }
    }
  };

  return (
    <ReportPage 
      title={`${customCaptions?.service} Status Change Reasons`}
      chartConfig={chartConfig}
    />
  );
};

export default ServiceStatusReport; 
